/*
  Carousels for the extra product-page rows - bestsellers, buy it again and
  browsing history.

  They all behave the same way: whole cards only, as many as the width fits,
  and never more cards per view than there actually are, so a short list never
  leaves an empty gap at the end of the row. The widths themselves are set in
  magnum-pdp-rows.css.
*/
(function () {
  'use strict';

  function init(slider) {
    if (!slider || slider.swiper || typeof Swiper === 'undefined') return;

    var slideCount = slider.querySelectorAll('.swiper-slide').length;
    if (!slideCount) return;

    var rowId = slider.getAttribute('data-row-id') || '';
    var size = slider.getAttribute('data-row-size') || 'product';

    /*
      The small browsing-history cards keep one size whatever the count, so
      two of them look the same as twenty rather than stretching to fill the
      width. Their width comes from the stylesheet.
    */
    var compact = size === 'compact';
    slider.style.setProperty('--row-count', slideCount);

    new Swiper(slider, {
      /* Dragging follows the hand rather than opening the product underneath. */
      grabCursor: true,
      simulateTouch: true,
      preventClicks: true,
      preventClicksPropagation: true,
      threshold: 5,
      spaceBetween: compact ? 15 : 5,
      /* Card widths come from magnum-pdp-rows.css, which only needs the count. */
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.magnum-row-next-' + rowId,
        prevEl: '.magnum-row-prev-' + rowId
      },
      breakpoints: compact ? {} : { 768: { spaceBetween: 15 } }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-row-slider]').forEach(init);
  }

  window.MagnumPdpRows = { init: init, initAll: initAll };

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });
  window.addEventListener('load', function () {
    initAll();
  });
})();
